// Yksi puhelin (2026-10-09): who the phone is doing an activity for right now, when that is the partner.
// A leaf module (no imports), read by the measurement code deep under a turn (an exercise's row, a
// listening result, a take's score), so those land with the right person without threading a prop
// through every screen:
//   - pedagogy/measure.ts: exercise rows and recording scores go as the partner's;
//   - listen/review.ts: a listening result likewise;
//   - ownerrors/store.ts noteMistake: no error card (the partner's own list is private to them);
//   - voices/dictation-grade.ts: no card grade (the partner's cards live on their own devices).
// The turn screen (onephone/Turn.tsx ActAs) sets it while the partner's turn is on screen and clears it
// when the turn ends. Results themselves (the task result, taps, takes, the tap) are written with an
// explicit `as`, never through this.

/** The partner a write is for (sent as X-Acting-As: the server records it as theirs, api/src/acting.ts). */
export interface Actor {
  userId: string;
}

let acting: Actor | null = null;

/** The partner whose turn is on screen, or null (the phone's own person, or no one-phone session). */
export function actingPartner(): Actor | null {
  return acting;
}

/** Set by the turn screen (and tests); null when the turn ends. */
export function setActingPartner(a: Actor | null): void {
  acting = a;
}

// ---------- the session's time, for both ----------

/**
 * On one phone both people spend the session's time together, but the shell's activity clock counts it
 * for the phone's person only. While a one-phone session runs, its state module answers whether an
 * activity's stretch is also the partner's (the couple session's own activities), and pedagogy/measure.ts
 * writes the same stretch for them.
 */
let twin: ((activity: string) => Actor | null) | null = null;

export function activityTwin(activity: string): Actor | null {
  return twin?.(activity) ?? null;
}

export function setActivityTwin(fn: ((activity: string) => Actor | null) | null): void {
  twin = fn;
}
